import React, { PureComponent, createRef } from 'react';
import { connect } from 'react-redux';
import { showModal, logout } from 'appSrc/redux/actions';
import LoginModal from 'appSrc/components/Auth/LoginModal';
import { Link } from 'react-router-dom';
import { PillButton } from 'appSrc/components/UI';
import ListCreationModal from 'appSrc/components/ListCreationModal';
import ProductModalManager from 'appSrc/components/Product/ModalManager';
import { DesireLogo, MenuIcon, RightIcon } from 'appSrc/v5/components/WildLifeIcons';
import { tdcDomainMatch } from 'appSrc/utils/random';
import style from './styles/style.module.css';
import styled, { css } from 'styled-components/macro';
import PropTypes from 'prop-types';

class NavBar extends PureComponent {
    state = {
        open: false,
    }
    componentDidMount() {
        var query = Object.decodeURLQuery( window.location.search );
        if( query.login === 'true' ) {
            this.props.showLogin();
        }
    }
    closeDrawer = () => {
        this.setState( { open: false } );
    }
    toggleDrawer = () => {
        this.setState( { open: !this.state.open } );
    }

    constructor(props) {
        super(props);
        // create a ref to store the textInput DOM element
        this.mainRef = createRef();
    }
    render() {
        const { loggedIn, scrollY, screenType } = this.props;
        const isDesktop = screenType === 'desktop';
        const usertype = this.props.self.user.usertype;

        let homeLink = tdcDomainMatch();

        return (
            <MainBar ref={this.mainRef}>
                { this.state.open &&
                    <div className={ style.overlay } onClick={ this.closeDrawer } />
                }
                <NavContainer>
                    <Nav scrollY={isDesktop && scrollY || 0} className={ style.navbar }>
                        <Col className={ style.left }>
                            <Link to={ homeLink } onClick={ this.closeDrawer }>
                                <DesireLogo className={ style.logo } />
                            </Link>
                            { usertype === 'admin' &&
                                <Link to='/admin' className={ style.link }>
                                    Admin Panel &#9881;
                                </Link>
                            }
                        </Col>
                        <Col className={ style.right }>
                            { !loggedIn &&
                                <PillButton className={ style.loginButton }
                                label="login"
                                onClick={ this.props.showLogin }
                                data-hook='login-button' />
                            }
                            { loggedIn &&
                                <div className={ style.link } onClick={ this.props.logout }>
                                    Logout <RightIcon className={ style.arrow } />
                                </div>
                            }
                            <Hamburger
                                className={ style.menuIcon }
                                onClick={ this.toggleDrawer } />
                        </Col>
                    </Nav>
                </NavContainer>
                { !this.props.loggedIn &&
                    <LoginModal />
                }
                <ListCreationModal />
                <ProductModalManager />
            </MainBar>
        );
    }
}

NavBar.propTypes = {
    scrollY: PropTypes.number,
};

NavBar.defaultProps = {
    scrollY: 0,
    title: 'Areas of Wisdom',
};

const mapStateToProps = ( state ) => {
    return {
        loggedIn: state.auth.loggedIn,
        self: state.self,
        categories: state.vars.interests,
        categoryTree: state.vars.categoryTree,
        screenType: state.screenSize.type,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        showLogin: () => {
            dispatch( showModal( 'loginModal' ) );
        },
        logout: () => {
            dispatch( logout() );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( NavBar );

const MainBar = styled.div`
    pointer-events: all;
`;
const Col = styled.div`
    flex-grow: 1;
    flex-basis: 0;
`;
const NavContainer = styled.div`
${({ isDesktop }) => css`
    ${isDesktop && `
        max-width: 87.25%;
        padding-left: 0;
        padding-right: 0;
        margin: 0 auto;
    `}
`}
`;
const Nav = styled.nav`
${({ scrollY }) => css`

    padding-top: 15px;
    padding-bottom: 15px;
    ${(scrollY > 100) && `
        padding-top: 5px;
        padding-bottom: 5px;
    `}
`}
`;

const Hamburger = styled(MenuIcon)`
    margin: 0 0 0 auto;
`;
